export const alkymetricsV2BaseURL = process.env.RAZZLE_RUNTIME_ALKYMETRICS_V2_URL;
export const screeningsBaseURL = process.env.RAZZLE_RUNTIME_SCREENINGS_API;
